import * as types from '../common/types'

export const setLogsPageNumber = (page: number) => ({
  type: types.SET_LOGS_PAGE_NUMBER,
  page
})

export const setLogsPageSize = (size: number) => ({
  type: types.SET_LOGS_PAGE_SIZE,
  size
})

export const toggleLogsExporting = () => ({ type: types.TOGGLE_LOGS_EXPORTING })

export const setLogsCount = (count: number) => ({
  type: types.SET_LOGS_COUNT,
  count
})
